// components/Sidebar.js
import '../styles/Sidebar.css';
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ role }) => {
  const location = useLocation(); // 現在のURLパスを取得

  return (
    <div className="sidebar">
      <h2 className="sidebar-title">メニュー</h2>
      <nav className="sidebar-nav">
        <div>
          <h3>カリキュラム</h3>
          <ul>
            <li>
              <Link 
                to="/curriculum" 
                className={`sidebar-link ${location.pathname === '/curriculum' ? 'active' : ''}`}
              >
                受講
              </Link>
            </li>
            <li>
              <Link 
                to="/test" 
                className={`sidebar-link ${location.pathname === '/test' ? 'active' : ''}`}
              >
                オンラインテスト
              </Link>
            </li>
            <li>
              <Link 
                to="/" 
                className={`sidebar-link ${location.pathname === '/' ? 'active' : ''}`}
              >
                概要
              </Link>
            </li>
          </ul>
        </div>
        
        <div>
          <hr />
          <h3>教材</h3>
          <ul>
            <li>
              <Link 
                to="/manual" 
                className={`sidebar-link ${location.pathname === '/manual' ? 'active' : ''}`}
              >
                作業支援AIアプリ
              </Link>
            </li>
            <li>
              <Link 
                to="/support" 
                className={`sidebar-link ${location.pathname === '/support' ? 'active' : ''}`}
              >
                マーケティング支援AIアプリ
              </Link>
            </li>
          </ul>
        </div>
        
        <div>
          <hr />
          <h3>診断</h3>
          <ul>
            <li>
              <Link 
                to="/diagnosis" 
                className={`sidebar-link ${location.pathname === '/diagnosis' ? 'active' : ''}`}
              >
                適職診断システム
              </Link>
            </li>
          </ul>
        </div>
        {role >= 5 && (
          <div>
            <hr />
            <h3>管理</h3>
            <ul>
              <li>
                <Link 
                  to="/admin" 
                  className={`sidebar-link sidebar-link-admin ${location.pathname === '/admin' ? 'active' : ''}`}
                >
                  管理者ページ
                </Link>
              </li>
            </ul>
          </div>
        )}
      </nav>
      {/* <a 
        href="https://discord.gg/F9UzsRgTbn" 
        className="discord-float-link"
        target="_blank" 
        rel="noopener noreferrer"
      >
        <i className="fab fa-discord" style={{ marginRight: '8px' }}></i>
        オーロラ博士に質問
      </a> */}
    </div>
  );
};

export default Sidebar;
